// extracted by mini-css-extract-plugin
export default {"Wrapper":"alert_Wrapper__ajSad"};